import Marquee from "react-fast-marquee";
import { SERVICES } from "@/data/content";

export default function EditorialMarquee({ dark = false }) {
    const items = [...SERVICES.map((s) => s.name), "Build What Endures"];
    return (
        <div
            data-testid="editorial-marquee"
            className={`py-6 border-y overflow-hidden ${dark ? "border-chalk/10 bg-graphite" : "border-graphite/10 bg-chalk"}`}
        >
            <Marquee speed={32} gradient={false} pauseOnHover>
                {items.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className={`font-serif font-light italic text-2xl md:text-3xl whitespace-nowrap ${dark ? "text-chalk/70" : "text-graphite/70"}`}>
                            {item}
                        </span>
                        <span className="mx-10 inline-block w-10 h-px bg-gold" aria-hidden="true" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
